export default __webpack_public_path__ + "static/media/customise.3a1f3b98.svg";